// Client for Clip's session (identity itself comes from "Sign in with
// Fawnroad" — a plain navigation to /auth/fawnroad/start, not a fetch call;
// see src/worker/index.ts and src/worker/fawnroad-oauth.ts).

export interface CurrentUser {
  displayName: string;
  email: string;
}

export async function fetchCurrentUser(): Promise<CurrentUser | null> {
  const res = await fetch('/api/auth/me');
  if (!res.ok) return null;
  return (await res.json()) as CurrentUser;
}

export async function logout(): Promise<void> {
  await fetch('/api/auth/logout', { method: 'POST' });
}
